import { TOKEN_KEY } from '../constants';
import { storageService } from '../storage/StorageService';

class ApiService {
    private getAuthHeader(): Record<string, string> {
        const token = storageService.get<string>(TOKEN_KEY);
        return token ? { Authorization: `Bearer ${token}` } : {};
    }

    public async request<T>(url: string, options: RequestInit = {}): Promise<T> {
        const headers = new Headers(options.headers);

        if (options.body !== undefined && !headers.has('Content-Type')) {
            headers.set('Content-Type', 'application/json');
        }

        for (const [key, value] of Object.entries(this.getAuthHeader())) {
            headers.set(key, value);
        }

        const response = await fetch(url, {
            cache: 'no-cache',
            ...options,
            headers,
        });

        const isJson = response.headers.get('content-type')?.includes('application/json');
        const data = isJson ? await response.json() : null;

        if (!response.ok) {
            throw new Error(data?.error || `HTTP ${response.status}`);
        }

        return data as T;
    }
}

export const apiService = new ApiService();
